<template>
  <div
    v-if="messages.length > 0 || isProcessing"
    :class="['flex flex-col', compact ? 'gap-2' : 'gap-4']"
  >
    <div
      v-for="msg in messages"
      :key="msg.id"
      :class="['flex flex-col text-sm', compact ? 'gap-0.5' : 'gap-1']"
    >
      <span
        :class="[
          'font-bold uppercase',
          compact ? 'text-[9px]' : 'text-[10px]',
          msg.role === 'user' ? 'text-gray-400' : 'text-blue-700'
        ]"
      >
        {{ msg.role === "user" ? "ME" : "REDRAW ASSISTANT" }}
      </span>
      <div
        v-if="msg.role === 'ai'"
        class="pin-messages-markdown text-gray-800"
        v-html="renderMarkdown(msg.content)"
      />
      <div
        v-else
        class="whitespace-pre-wrap text-gray-800"
        v-html="injectHexColorPreviews(msg.content)"
      />
    </div>
    <div v-if="isProcessing" :class="['flex flex-col text-sm', compact ? 'gap-0.5' : 'gap-1']">
      <span :class="['font-bold uppercase text-blue-700', compact ? 'text-[9px]' : 'text-[10px]']">
        REDRAW ASSISTANT
      </span>
      <div :class="['flex items-center', compact ? 'gap-1.5 text-xs' : 'gap-2 text-sm']">
        <UseSvg
          icon="loader"
          :class="['shrink-0 animate-spin text-blue-600', compact ? 'h-3.5 w-3.5' : 'h-4 w-4']"
        />
        <span :class="['text-gray-500', compact ? 'text-xs' : 'text-sm']">
          {{ thinkingText || "Thinking..." }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import UseSvg from "common/vue/components/UseSvg.vue";
import { injectHexColorPreviews, useMarkdownRenderer } from "./composables/useMarkdownRenderer";

defineOptions({ name: "PinMessages" });

defineProps({
  messages: { type: Array, default: () => [] },
  isProcessing: { type: Boolean, default: false },
  thinkingText: { type: String, default: undefined },
  compact: { type: Boolean, default: false }
});

const { renderMarkdown } = useMarkdownRenderer();
</script>

<style scoped>
.pin-messages-markdown :deep(p) {
  @apply mb-2 last:mb-0;
}
.pin-messages-markdown :deep(ul) {
  @apply ml-4 list-disc;
}
.pin-messages-markdown :deep(ol) {
  @apply ml-4 list-decimal;
}
.pin-messages-markdown :deep(a) {
  @apply text-blue-600 underline hover:text-blue-800;
}
.pin-messages-markdown :deep(strong) {
  @apply font-semibold;
}
.pin-messages-markdown :deep(code) {
  @apply rounded bg-gray-100 px-1 py-px font-mono text-[13px];
}
.pin-messages-markdown :deep(blockquote) {
  @apply border-l-4 border-gray-300 pl-3 italic text-gray-600;
}
</style>
